import {
  Box,
  Button,
  CircularProgress,
  InputBase,
  Paper,
  alpha,
  styled,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import filter from "../../../assets/svg/filter.svg";
// import DataTableComponent from "../../../components/common/DataTable/DataTable";
import CleverDataTable from "./CleverDataTable.jsx";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import DataTableComponent from "../../../components/common/DataTable/DataTable.js";
import { generateCleverColumns } from "./helper.js";
import { useNavigate } from "react-router-dom";
import {
  collection,
  doc,
  getDocs,
  onSnapshot,
  query,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../../firebaseConfig.js";
import { toast } from "react-toastify";
const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: "12px",
  backgroundColor: "#FAFAFA",
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  height: "40px",
  [theme.breakpoints.up("sm")]: {},
  border: "1px solid #EEEEEE",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "230px",
  },
}));

const initialData = [
  {
    id: 1,
    createdAt: "2024-09-01",
    page: "Page1",
    snippetTitle: "Understanding React State",
    snippetView: 120,
    articleView: 450,
    helpfullYes: 50,
    helpfullNo: 5,
    status: "Active",
    action: <MoreHorizIcon />,
  },
  {
    id: 2,
    createdAt: "2024-09-02",
    page: "Page2",
    snippetTitle: "React Hooks Overview",
    snippetView: 100,
    articleView: 300,
    helpfullYes: 30,
    helpfullNo: 3,
    status: "Active",
    action: <MoreHorizIcon />,
  },
  {
    id: 3,
    createdAt: "2024-09-03",
    page: "Page3",
    snippetTitle: "State Management in React",
    snippetView: 150,
    articleView: 500,
    helpfullYes: 70,
    helpfullNo: 10,
    status: "InActive",
    action: <MoreHorizIcon />,
  },
  {
    id: 4,
    createdAt: "2024-09-04",
    page: "Page4",
    snippetTitle: "Using useState in React",
    snippetView: 130,
    articleView: 400,
    helpfullYes: 40,
    helpfullNo: 8,
    status: "Active",
    action: <MoreHorizIcon />,
  },
  {
    id: 5,
    createdAt: "2024-09-05",
    page: "Page5",
    snippetTitle: "Advanced React Patterns",
    snippetView: 110,
    articleView: 350,
    helpfullYes: 35,
    helpfullNo: 6,
    status: "Active",
    action: <MoreHorizIcon />,
  },
];

const columns = [
  { id: "date", label: "Date" },
  { id: "cleverpage", label: "Cleverpage" },
  { id: "snippetTitle", label: "Snippet Title" },
  { id: "snippetView", label: "Snippet View" },
  { id: "articleView", label: "Article View" },
  { id: "helpfulYes", label: "Helpful Yes" },
  { id: "helpNo", label: "Help No" },
  { id: "activeStatus", label: "Active Status" },
  { id: "action", label: "Action" },
];

export default function CleverList() {
  const [searchValue, setSearchValue] = useState("");
  const [datatitle, setDatatitle] = useState(columns);
  const [datatable, setDatatable] = useState(initialData);
  const [snippetData, setSnippetData] = useState([]);
  const [snippetDataFilter, setSnippetDataFilter] = useState([]);
  const [loading, setLoading] = useState([]);
  const navigate = useNavigate();
  console.log(snippetDataFilter, "snippetDataFilter");

  const statusHandler = async (row, isActive) => {
    try {
      const snippetDocRef = doc(
        db,
        "cleverSnippet",
        row.cleverPageName,
        "snippets",
        row.id
      );

      // Update the document with the modified isActive value
      await updateDoc(snippetDocRef, {
        isActive: isActive,
      });
      handler();
      toast.success(
        `Snippet ${isActive ? "Activated" : "Deactivated"} Successfully`
      );
    } catch (error) {
      console.error("Error updating snippet status:", error);
      toast.error("Error updating snippet status");
    }
  };

  const searchHandler = (search) => {
    setSearchValue(search);
    let filterSearch = snippetData.filter((d) =>
      d.snippetName.toLowerCase().includes(search.toLowerCase())
    );
    console.log(filterSearch, "filterSearch");

    setSnippetDataFilter(filterSearch);
  };

  const menuOptions = useMemo(
    () => [
      {
        id: "edit",
        iconName: "mdi:square-edit-outline",
        actionName: "Edit",
        // redirectUrl:'/systems/route-partner/addNew',
        onClickHandle: (row) => {
          console.log("id in edit", row?.id);
          navigate("/users/clever/add-new-clever", {
            state: { id: row?.id, row: row },
          });
        },
      },
      {
        id: "deactivate",
        iconName: "user",
        actionName: "Deactivate",
        onClickHandle: (row) => {
          statusHandler(row, false);
        },
      },
      {
        id: "activate",
        iconName: "user",
        actionName: "Activate",
        onClickHandle: (row) => {
          statusHandler(row, true);
        },
      },
    ],
    []
  );

  useEffect(() => {
    handler();
  }, []);

  async function handler() {
    setLoading(true);
    try {
      const querySnapshot = collection(db, "cleverSnippet");
      const q = query(querySnapshot);
      onSnapshot(q, async (snapshot) => {
        const arr = [];
        const finalarr = [];
        snapshot.forEach((doc) => {
          arr.push({ ...doc.data() });
        });
        console.log(arr, "arr of snippet");
        for (let d of arr) {
          const querySnapshot = await getDocs(
            collection(db, "cleverSnippet", d.cleverPageName, "snippets")
          );
          // console.log(querySnapshot.docs, "querySnapshot");
          querySnapshot.docs.map((doc) =>
            finalarr.push({
              ...doc.data(),
              cleverPageName: d.cleverPageName,
              id: doc.id,
            })
          );
        }
        setSnippetData(finalarr);
        setSnippetDataFilter(finalarr);
        setLoading(false);
        console.log(finalarr, "finalarr of snippet");
      });
    } catch (err) {
      console.log(err, "err");
      setLoading(false);
    }
  }

  const CleverColumns = generateCleverColumns(menuOptions);

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ p: "24px 16px", paddingLeft: "0px" }}>
          <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search…"
              inputProps={{ "aria-label": "search" }}
              value={searchValue}
              onChange={(e) => searchHandler(e.target.value)}
            />
          </Search>
        </Box>
        <Box sx={{ display: "flex" }}>
          <Box>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#5E17EB",
                color: "#fff",
                marginLeft: "20px",
                border: "1px solid #E5E5E8",
                borderRadius: "4px",
                boxShadow: "none",
                whiteSpace: "nowrap",
                fontWeight: 600,
                marginTop: "20px",
                "&:hover": {
                  outline: "none",
                  color: "#fff",
                  backgroundColor: "#5E17EB", // Remove border color on focus
                },
              }}
              onClick={() => navigate("/users/clever/add-new-clever")}
            >
              Add New Snippet
            </Button>
          </Box>
        </Box>
        {/* <Box sx={{ display: "flex" }}>
          <Box>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "white",
                color: "#1C2630",
                border: "1px solid #E5E5E8",
                borderRadius: "4px",
                boxShadow: "none",
                whiteSpace: "nowrap",
                fontWeight: 600,
                marginTop: "20px",
                "&:hover": {
                  outline: "none",
                  color: "#1C2630",
                  backgroundColor: "white",
                },
              }}
            >
              <img src={filter} alt="star" style={{ marginRight: "10px" }} />
              Filter
            </Button>
          </Box>
        </Box> */}
      </Box>
      <Box sx={{ display: "contents" }}>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              mt: "16px",
            }}
          >
            <CircularProgress size={30} />
          </Box>
        ) : (
          <Paper
            sx={{
              width: "100%",
              border: "1px solid #E5E5E8",
              borderRadius: "4px",
            }}
          >
            <DataTableComponent
              data={snippetDataFilter}
              columns={CleverColumns}
            />
          </Paper>
        )}
      </Box>
    </div>
  );
}
